import { PriceSuggestionType } from '@retail/products/types';
import { PriceSuggestionTypeWithCountDTO } from '../dto';

export type AcceptedImportColumn = 'mgItem' | 'supplierId' | 'validFrom' | 'validTo' | 'salesPrice';

export interface PriceSuggestionPriceItem {
  mgItemNumber: number;
  primaryText: string;
  mgSupplierId: number;
  mgSupplierName: string;
  mgSupplierItemId: number;
  price?: number | null;
  validFrom: Date;
  validTo?: Date;
}

export interface PriceSuggestionTypeWithCountProps {
  suggestionType: PriceSuggestionType;
  count: number;
}

export class PriceSuggestionTypeWithCount {
  suggestionType: PriceSuggestionType;
  count: number;

  constructor({ suggestionType, count }: PriceSuggestionTypeWithCountProps) {
    this.suggestionType = suggestionType;
    this.count = count;
  }

  static fromDto = ({
    suggestionType,
    count,
  }: PriceSuggestionTypeWithCountDTO): PriceSuggestionTypeWithCount => {
    return new PriceSuggestionTypeWithCount({
      suggestionType,
      count,
    });
  };
}
